import { ButtonBase } from '@mui/material';
import { Popover } from 'antd';
import { useEffect, useState } from 'react';

const GuarantorSwitchBox = (props) => {
  const { tabs, handler } = props;
  const [tabIdx, setTabIdx] = useState(0);
  const handleSwitch = (idx) => {
    setTabIdx(idx);
    if (handler) {
      handler(idx);
    }
  };

  useEffect(() => {
    handler(0);
  }, []);

  return (
    <div className={`switch_tab mr-[20px] inline-block p-[10px_0px] `}>
      <div className='rounded-[4px] bg-[#F5F5F5] p-[3px] flex'>
        {tabs.map((tab, idx) => {
          return (
            <ButtonBase key={idx}>
              <span
                className={`switch ${
                  tabIdx === idx && 'active'
                } flex items-center justify-center gap-[10px]`}
                onClick={() => handleSwitch(idx)}
              >
                {tab.name}
                {tab?.sign_status === 'no' && (
                  <Popover content='Need Signature'>
                    <img className='' src='/images/wrong.png' />
                  </Popover>
                )}
              </span>
            </ButtonBase>
          );
        })}
      </div>
    </div>
  );
};

export default GuarantorSwitchBox;
